import { render, staticRenderFns } from "./AutorizarProspecto.vue?vue&type=template&id=5655eabd&"
import script from "./AutorizarProspecto.vue?vue&type=script&lang=js&"
export * from "./AutorizarProspecto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports